import { logError } from '../lib/logger';
import { useState, useEffect, useCallback } from 'react';
import { getReminders, acknowledgeReminder } from '../lib/api';
import { Bell, X, Clock } from '@phosphor-icons/react';
import { Button } from './ui/button';

export default function Reminders() {
  const [reminders, setReminders] = useState([]);
  const [visible, setVisible] = useState(true);

  const loadReminders = useCallback(async () => {
    try {
      const data = await getReminders();
      setReminders(data);
    } catch (e) {
      logError('Failed to load reminders:', e);
    }
  }, []);

  useEffect(() => {
    loadReminders();
    const interval = setInterval(loadReminders, 60000);
    return () => clearInterval(interval);
  }, [loadReminders]);

  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const isPreHuddleTime = hours === 8 && minutes >= 15 && minutes <= 45;
  const isEODTime = hours >= 16;

  const handleAcknowledge = useCallback(async (id) => {
    try {
      await acknowledgeReminder(id);
      loadReminders();
    } catch (e) {
      logError('Failed to acknowledge reminder:', e);
    }
  }, [loadReminders]);

  if (!visible) return null;

  const showTimeReminder = isPreHuddleTime || isEODTime;

  return (
    <>
      {showTimeReminder && (
        <div className={`px-4 py-3 flex items-center justify-between ${
          isPreHuddleTime ? 'bg-amber-100/50 border-b border-amber-300/30 dark:bg-amber-900/20 dark:border-amber-800/30'
          : 'bg-red-100/50 border-b border-red-300/20 dark:bg-red-900/20 dark:border-red-800/30'
        }`} data-testid="time-reminder-banner">
          <div className="flex items-center gap-3">
            <Bell size={18} weight="fill" className={isPreHuddleTime ? 'text-amber-600' : 'text-red-600'} />
            <span className="text-sm font-medium text-foreground">
              {isPreHuddleTime
                ? 'Daily Huddle Reminder: Please update your hot files before the 9:00 AM call'
                : 'End of Day Reminder: Resolve all outstanding action items before leaving'}
            </span>
          </div>
          <Button variant="ghost" size="icon" onClick={() => setVisible(false)} className="h-6 w-6" data-testid="dismiss-reminder-btn">
            <X size={14} />
          </Button>
        </div>
      )}

      {reminders.length > 0 && (
        <div className="px-4 py-2 bg-background border-b border-border space-y-1" data-testid="active-reminders">
          {reminders.map((r) => (
            <div key={r.id} className="flex items-center justify-between py-1">
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Clock size={14} />
                <span>{r.message}</span>
              </div>
              <Button variant="ghost" size="sm" onClick={() => handleAcknowledge(r.id)}
                className="text-xs h-6 text-muted-foreground hover:text-foreground" data-testid={`ack-reminder-${r.id}`}>
                Dismiss
              </Button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
